"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateSitemapV2 = void 0;
const buildUrlTemplate = (host, locale, defaultLocale) => `${host}${locale !== defaultLocale ? `/${locale}` : ""}`;
const generateSitemapV2 = (options) => {
    return options.paths.map((path) => {
        const startOfTheDay = new Date();
        startOfTheDay.setUTCHours(0, 0, 0, 0);
        const languages = options.locales.reduce((acc, locale) => {
            return {
                ...acc,
                [locale]: `${path.replace(options.startPathToSubstitute, buildUrlTemplate(options.host, locale, options.defaultLocale))}`,
            };
        }, {});
        return {
            url: `${path.replace(options.startPathToSubstitute, buildUrlTemplate(options.host, options.defaultLocale, options.defaultLocale))}`,
            lastModified: startOfTheDay,
            changeFrequency: "daily",
            priority: 1,
            alternates: {
                languages,
            },
        };
    });
};
exports.generateSitemapV2 = generateSitemapV2;
//# sourceMappingURL=templateV2.js.map